import request from "@/utils/request";


export function materialGetAllForDropdown() {
    return request({
        url: "/api/services/app/Material/GetAllForDropDown",
        method: "GET"
    });
}


// WEBPACK FOOTER //
// ./src/api/material.js